
import { Component, Vue } from 'vue-property-decorator';

import { configFormDataFactory } from '@/views/Onboarding/helpers';

import { ConfigFormData, ConfigFormDataValueType } from '@/models/onboarding';
import isMobile from '@/utils/mobile-check';
import { convertCoinsPurchasePercentToRatio } from '@/utils/coinsHelper';

@Component
export default class LoyaltySetupBase extends Vue {
  formData: ConfigFormData = configFormDataFactory();
  formDataExample: ConfigFormData = configFormDataFactory();

  get percentInCoins() {
    const { value, type, customValue } = this.valueIsSelected
      ? this.formData
      : this.formDataExample;

    const isCustomLoyalty = type === 'custom';

    const parsedValue = isCustomLoyalty ? Number(customValue) : Number(value);

    return parsedValue;
  }

  get coinPurchaseRatio() {
    return convertCoinsPurchasePercentToRatio(this.percentInCoins);
  }

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  get valueIsSelected() {
    const { value, customValue } = this.formData;

    return value || customValue;
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get businessLogo() {
    const business = this.businessInfo;

    if (!business) return '';

    return (
      (business.logo &&
        business.logo.publicPath &&
        business.logo.publicPath.large) ||
      ''
    );
  }

  get deviceIsMobile() {
    return isMobile();
  }

  handleItemMouseEnter(value: number, type: ConfigFormDataValueType) {
    if (this.deviceIsMobile || this.valueIsSelected) return;

    const { state } = this.formDataExample;

    Object.assign(this.formDataExample, { customValue: '' });

    if (!state[value]) {
      Object.assign(this.formDataExample, {
        value,
        type,
        state: {
          [value]: true
        }
      });

      return;
    }

    Object.assign(this.formDataExample, configFormDataFactory());
  }

  handleItemMouseLeave() {
    if (this.deviceIsMobile || this.valueIsSelected) return;

    Object.assign(this.formDataExample, configFormDataFactory());
  }

  handleChangeLoyaltyConfig(formData: ConfigFormData) {
    this.formData = formData;
  }
}
